var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-category-add"},[_c('CategorySelector',{ref:"categorySelector",staticClass:"product-category-add__selector"}),_c('div',{staticClass:"btn-wrap-main product-category-add__btn-wrap-main"},[_c('button',{staticClass:"btn-main blue",attrs:{"type":"button"},on:{"click":_vm.register}},[_vm._v(" 등록 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }